/// <reference path="../standingAppointments/standingAppointments.context.ts" />
/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.StandingBlocks {
    "use strict";

    export class StandingBlocksContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        appointmentBookModalService: Meevo.Plugins.AppointmentBook.Services.AppointmentBookModalService;
        $q: angular.IQService;

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            appointmentBookModalService: Meevo.Plugins.AppointmentBook.Services.AppointmentBookModalService,
            $q: angular.IQService,
            private durationIncrements) {
            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);
            this.appointmentBookModalService = appointmentBookModalService;
            this.$q = $q;
            this.baseEndpoint = appSettings.API_ENDPOINTS.blockSchedule;
            this.sectionTemplatePath = "app/plugins/standingBlocks/sectionViews/";
            this.buildCrudSecurityKeys(this.securityKeys.APPOINTMENTS_BLOCKDEFINITION_TAB_MAIN);
            this.entityType = 'BlockDefinition';
            this.initializeSections();
        }

        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.APPOINTMENTS_BLOCKDEFINITION_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0, "SECTION_BLOCK_DEFINITION_MAIN", "main.html", true, false, this.baseEndpoint, "",
                    this.loggingService, this.dataService, this.durationIncrements, this.identityService, Meevo.Model.NounEnum.BlockScheduleMain, this.appSettings, this.securityKeys.APPOINTMENTS_BLOCKDEFINITION_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
        }

        get showUndelete(): boolean {
            return false;
        }

        postCancel() {
            if (Model.Guard.isSomething(this.selectedSection.model)) {
                this.selectedSection.sectionModelRetrieved();
            }
            super.postCancel();
        }

        postSave(model: any): void {
            model.suppressWarnings = false;
            super.postSave(model);
        }

        handleWarningsConfirm(warnings: any[]): ng.IPromise<boolean> {
            var deferred = this.$q.defer<boolean>();
            this.appointmentBookModalService.showMessages(warnings, "HEADER_BLOCK_WARNING", {
                buttonsType: Meevo.Model.ButtonTypeEnum.YesNo,
                callback: (messageResult) => {
                    deferred.resolve(messageResult === Meevo.Model.MessageBoxButtonResult.Yes);
                }
            });

            return deferred.promise;
        }


        private deleteBlockSchedule(endpoint: string) {
            let vm = this;

            vm.loadingInProgress = true;

            // Patch model object state to deleted
            vm.dataService.objectStatePatch(
                vm.baseEndpoint,
                vm.itemId,
                vm.selectedSection.model.entityVersion,
                <number>Model.ObjectStateEnum.Deleted,
                vm.asLocationId,
                endpoint
            ).then((data) => {
                if (data) {
                    vm.selectedSection.model = data;
                    vm.selectedSection.sectionModelRetrieved();
                    vm.loggingService.trace('Delete saved.');
                }
                this.postDelete();
            })
            .finally(() => {
                vm.loadingInProgress = false;
            });
        }

        /**
         * Deletes the selected item.
         */
        delete(): void {
            let vm = this;
            
            if (this.canDelete) {
                this.modalService.warning(this.deleteConfirmationMessageKey, 0, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                    .then(() => {
                    let endpoint = '';

                    this.dataService.customMethodData(`/api/blockSchedule/${vm.itemId}/existsToday`, 'GET', null).then((result: any) => {
                        let blockScheduleExistsToday = result.data;
                        if (blockScheduleExistsToday) {
                            this.modalService.confirmHandler("MESSAGE_STANDING_DEFINITION_BLOCK_DELETE_TODAY").then((response: boolean) => {
                                if (response) {
                                    endpoint = 'deleteToday';
                                }
                                this.deleteBlockSchedule(endpoint);
                            });
                        } else {
                            this.deleteBlockSchedule(endpoint);
                        }
                    });

                });
            } else {
                this.modalService.alert("ERROR_HTTP_403");
            }
            this.usageTrackingLog(Meevo.Model.VerbEnum.DeleteButtonClicked, null);
        }

        postDelete(): void
        {
            this.usageTrackingLog(Meevo.Model.VerbEnum.Deleted, null);
        }
    }
}